<div class="contentHeight histoContainer">
    <div class="container">
        <div class="head">
            <h3 [translate]="'planning.manageRDV'" class="containerTitle"></h3>
            <button class="btn btn-secondary btn-sm" id="btnNewRdv" routerLink="/planning" [translate]="'planning.newRDV'"></button>
        </div>
        <div>
            <mat-radio-group class="time">
                <mat-radio-button [value]=0 [checked]="true" class="radio" (change)="radioChange(0)">{{'planning.next'|translate}}</mat-radio-button>
                <mat-radio-button [value]=1 class="radio" (change)="radioChange(1)">{{'planning.all'|translate}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="row mx-auto histoContent">
            <mat-table class="table lstdossier bg-white table-hover" [dataSource]="planningSource" matSort (matSortChange)="sortScale($event,'1')">
                <!--ID-->
                <ng-container matColumnDef="rdvID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.rdvId'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.rdvId'|translate}}</span>
                            <span class="col-9 col-lg-12 col-md-12 col-sm-12">{{res.rdv.rdvID}}</span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Statut-->
                <ng-container matColumnDef="statusRDV">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.status'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.status'|translate}}</span>
                            <span class="status col-9 col-lg-12 col-md-12 col-sm-12">
                                <i aria-hidden="true" *ngIf="res.rdv.status == 1" class="fas fa-check fa-1-2x green" matTooltip="{{'planning.status1'|translate}}"></i>
                                <i aria-hidden="true" *ngIf="res.rdv.status == 2" class="fas fa-trash-alt fa-1-2x" matTooltip="{{'planning.status2'|translate}}"></i>
                            </span>
                            <span class="mobile-text col-9 col-lg-12 col-md-12 col-sm-12">
                                <p *ngIf="res.rdv.status == 1" class="noMargin">{{'planning.status1'|translate}}</p>
                                <p *ngIf="res.rdv.status == 2" class="noMargin">{{'planning.status2'|translate}}</p>
                            </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Date rdv-->
                <ng-container matColumnDef="dateRDV">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.date'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.date'|translate}}</span>
                            <span class="col-9 col-lg-12 col-md-12 col-sm-12">
                                {{res.rdv.startDate | date:'dd/MM/yyyy HH:mm'}}
                            </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Heure début rdv-->
                <!--<ng-container matColumnDef="hourRDV" >
              <mat-header-cell *matHeaderCellDef > {{'planning.hour'|translate}} </mat-header-cell>
              <mat-cell *matCellDef="let res">{{res.rdv.startDate | date:'HH:mm'}}</mat-cell>
            </ng-container>-->
                <!--Durée du rdv-->
                <ng-container matColumnDef="duration">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.duration2'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.duration2'|translate}}</span>
                            <span class="col-9 col-lg-12 col-md-12 col-sm-12">{{res.rdv.duration}}</span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Type d'intervention-->
                <ng-container matColumnDef="typeIntervention">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.type'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.type2'|translate}}</span>
                            <span class="col-9 col-lg-12 col-md-12 col-sm-12">{{res.typeIntervention}}</span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Utilisateur-->
                <ng-container matColumnDef="user">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> {{'planning.site'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.site'|translate}}</span>
                            <span class="col-9 col-lg-12 col-md-12 col-sm-12">{{res.user_SocialReason | uppercase}} - {{res.user_FirstName | titlecase}}  {{res.user_Name | uppercase}}</span>
                        </div>
                    </mat-cell>
                </ng-container>
                <!--Annuler le rdv-->
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef> {{'planning.action'|translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let res" [ngClass]="!res.canCancel ? 'hide-on-mobile' : ''">
                        <div class="row mobile-div">
                            <span class="mobile-label col-3">{{'planning.action'|translate}}</span>
                            <div *ngIf="res.canCancel" class="action col-8 col-lg-12 col-md-12 col-sm-12 pointer" (click)="cancel(res.rdv.rdvID)">
                                <i aria-hidden="true" class="far fa-times fa-2x primaryRed" matTooltip="{{'planning.cancel'|translate}}"></i>
                            </div>
                            <button *ngIf="res.canCancel" id="btnCancel" class="btn btn-danger col-3" (click)="cancel(res.rdv.rdvID)">{{'planning.cancel' | translate}}</button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
        </div>
    </div>
</div>

<div id="cancelModal" class="modal">
    <div class="modal-content" id="cancelContent">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('cancelModal');">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed "></i>
            </span>
            <h1 class="modal-title"> {{'planning.cancelTitle'|translate}} </h1>
            <hr />
        </div>
        <div class="row mt-3 mb-3" *ngIf="showCancelModal">
            <span class="col-12 text-center mb-4">{{'planning.cancelMsg'|translate}} ? </span>
            <h3 class="col-12 text-center">
                {{currentRdv.rdv.startDate | date:'dd/MM/yyyy'}} - {{currentRdv.rdv.startDate |  date:'HH:mm'}}
            </h3>
            <span class="col-12 text-center modal-text">{{currentRdv.user_SocialReason | uppercase}} - {{currentRdv.user_FirstName | titlecase}}  {{currentRdv.user_Name | uppercase}}</span>
            <span class="col-12 text-center modal-text">{{currentRdv.typeIntervention }}</span>
        </div>
        <div class="row" style="display: flex; justify-content: center;">
            <button class="btn btn-success col-2 col-lg-2 col-md-2 col-sm-2 mr-2" (click)="ValidCancel(true)">{{'planning.oui' | translate | titlecase}}</button>
            <button class="btn btn-danger col-2 col-lg-2 col-md-2 col-sm-2 ml-2" (click)="ValidCancel(false)">{{'planning.non' | translate | titlecase}}</button>
        </div>
    </div>
</div>

<div id="loadingModal" class="modal">
    <div class="modal-content" id="loadingContent">
        <div class="col-12 mt-5 mb-5 row justify-content-center loader-black">
            <mat-spinner diameter="70"> </mat-spinner>
        </div>
    </div>
</div>

<div id="errorModal" class="modal">
    <div class="modal-content" id="errorContent">
        <h1 class="text-center mt-3" [translate]="'planning.errorTitle'"></h1>
        <span class="text-center mt-3" [translate]="'planning.errorMsg'"></span>
        <button class="btn btn-secondary col-lg-2 col-md-2 col-sm-3 col-4"
                style="align-self:center;"
                (click)="closeError()" [translate]="'planning.closeError'"></button>
    </div>
</div>

